var React = require('react');

function Smiley (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M12 0c-6.617 0-12 5.383-12 12s5.383 12 12 12 12-5.383 12-12-5.383-12-12-12zm0 23c-6.065 0-11-4.935-11-11s4.935-11 11-11 11 4.935 11 11-4.935 11-11 11zM19.5 12.5c-.276 0-.5.224-.5.5 0 3.859-3.14 7-7 7s-7-3.141-7-7c0-.276-.224-.5-.5-.5s-.5.224-.5.5c0 4.411 3.589 8 8 8s8-3.589 8-8c0-.276-.224-.5-.5-.5zM5.5 10.5c.276 0 .5-.224.5-.5 0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5c0 .276.224.5.5.5s.5-.224.5-.5c0-1.379-1.122-2.5-2.5-2.5s-2.5 1.121-2.5 2.5c0 .276.224.5.5.5zM14.5 10.5c.276 0 .5-.224.5-.5 0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5c0 .276.224.5.5.5s.5-.224.5-.5c0-1.379-1.122-2.5-2.5-2.5s-2.5 1.121-2.5 2.5c0 .276.224.5.5.5z"})));
}

Smiley.defaultProps = {"version":"1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Smiley;

Smiley.default = Smiley;
